var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("common-content", [
    _c(
      "div",
      { staticClass: "news-content" },
      [
        _c("page-title", { attrs: { pageName: _vm.pageName } }),
        _c("div", { staticClass: "news-produce" }, [_vm._v(_vm._s(_vm.pro))]),
        _c("div", { staticClass: "news-list" }, [
          _c(
            "ul",
            _vm._l(_vm.pageData, function(item, index) {
              return _c(
                "li",
                {
                  key: item.id,
                  staticClass: "project-list_detail",
                  class: { left: index % 2 === 1 }
                },
                [
                  _c(
                    "nuxt-link",
                    {
                      staticClass: "news-image",
                      attrs: { to: "/news/" + item.id + "?lang=" + _vm.lang }
                    },
                    [_c("img", { attrs: { src: item.mainImg, alt: "" } })]
                  ),
                  _c("div", { staticClass: "news-detail" }, [
                    _c("h2", { staticClass: "news-title" }, [
                      _vm._v(_vm._s(item.title))
                    ]),
                    _c("h6", { staticClass: "news-time" }, [
                      _vm._v(_vm._s(item.time))
                    ]),
                    _c("p", { staticClass: "news-tips" }, [
                      _vm._v(_vm._s(_vm._f("profile")(item.content)))
                    ])
                  ]),
                  _c(
                    "nuxt-link",
                    {
                      staticClass: "news-more",
                      attrs: { to: "/news/" + item.id + "?lang=" + _vm.lang }
                    },
                    [
                      _c("span", [_vm._v(_vm._s(_vm.pros))]),
                      _c("i", { staticClass: "icon icon-arrowright" })
                    ]
                  )
                ],
                1
              )
            }),
            0
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-452e6662", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-452e6662","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/news/index.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-452e6662","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/news/index.vue
// module chunks = 10